import { TENANT_ID } from 'global/constants';

import { isRegisteringInstallerGuestOnly } from 'utils/InstallerUtils';
import { getTenantId } from 'utils/tenantUtil';

export const NEFIFormIV = (valuesEmailInput, valuesBranchSelection, valuesForm) => ({
  companyName1: '',
  companyName2: '',
  companyName3: '',
  b_anrede_id: '',
  taetigkeitsschwerpunkt: '',
  companyOwner: '',
  companyCountry: '',
  companyStreet: '',
  companyHouseNumber: '',
  companyPostal: '',
  companyCity: '',
  companyRegion: '',
  companyPostalCity: '',
  companyStreetId: '',
  companyRegionId: '',
  gridProviderEnergy: '',
  gridProviderGas: '',
  foreignCompanyIdEnergy: '',
  foreignCompanyIdGas: '',
  phone: '',
  mobile: '',
  craftsChamberArea: '',
  craftsChamberNumber: '',
  craftsChamberDate: '',
  businessRegistrationLocation: '',
  businessRegistrationDate: '',
  commercialRegisterNumber: '',
  commercialRegisterLocation: '',
  commercialRegisterDate: '',
  doesNeedAvaGuestPostal:
    TENANT_ID.AVA === getTenantId() && isRegisteringInstallerGuestOnly(valuesBranchSelection),
  avaGuestPostal: '',
  experts: [],
  ...(valuesForm || {}),
  ...valuesEmailInput,
});
